import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const linkBase = 'text-sm font-medium transition-colors text-slate-300 hover:text-white';
const linkActive = 'text-sky-400 hover:text-sky-400';
const dropdownItem = 'block px-4 py-2 text-sm text-slate-200 hover:bg-slate-800 hover:text-white transition-colors';
const dropdownItemActive = 'text-sky-400 hover:text-sky-400';

function isAdmin() {
  try {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    return Array.isArray(roles) && roles.includes('administrator');
  } catch (err) {
    return false;
  }
}

function Chevron() {
  return (
    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

class Navbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: localStorage.getItem('username'),
      menuOpen: false,
      randevularOpen: false,
      hesapOpen: false
    };
    this.navRef = React.createRef();
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleAuthChange = this.handleAuthChange.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.toggleRandevularMenu = this.toggleRandevularMenu.bind(this);
    this.toggleHesapMenu = this.toggleHesapMenu.bind(this);
    this.closeDropdowns = this.closeDropdowns.bind(this);
  }

  componentDidMount() {
    window.addEventListener('auth-changed', this.handleAuthChange);
    window.addEventListener('storage', this.handleAuthChange);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('auth-changed', this.handleAuthChange);
    window.removeEventListener('storage', this.handleAuthChange);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleAuthChange() {
    this.setState({ username: localStorage.getItem('username') });
  }

  handleOutsideClick(event) {
    if (this.navRef.current && !this.navRef.current.contains(event.target)) {
      this.closeDropdowns();
    }
  }

  toggleMenu() {
    this.setState(prev => ({ menuOpen: !prev.menuOpen }));
  }

  toggleRandevularMenu() {
    this.setState(prev => ({ randevularOpen: !prev.randevularOpen, hesapOpen: false }));
  }

  toggleHesapMenu() {
    this.setState(prev => ({ hesapOpen: !prev.hesapOpen, randevularOpen: false }));
  }

  closeDropdowns() {
    this.setState({ randevularOpen: false, hesapOpen: false });
  }

  render() {
    const { menuOpen, randevularOpen, hesapOpen } = this.state;
    const isAuthenticated = !!localStorage.getItem('auth');

    return (
      <nav className="sticky top-0 z-50 w-full border-b border-slate-800 bg-slate-900 text-white shadow-sm">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <NavLink to="/" className="flex items-center gap-2 font-heading text-xl font-bold tracking-tight text-white hover:opacity-90 transition-opacity">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-sky-600">
              <span className="text-white font-bold leading-none">R</span>
            </div>
            Randevu
          </NavLink>

          <div className="hidden md:flex items-center gap-6" ref={this.navRef}>
            {isAuthenticated ? (
              <>
                <div className="relative">
                  <button type="button" onClick={this.toggleRandevularMenu} className={linkBase + ' inline-flex items-center gap-1'}>
                    Randevular
                    <Chevron />
                  </button>
                  {randevularOpen && (
                    <div className="absolute right-0 mt-2 w-52 rounded-lg border border-slate-800 bg-slate-900 shadow-lg py-1">
                      <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/takvim" onClick={this.closeDropdowns}>Takvim</NavLink>
                      <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/gunluk-randevular" onClick={this.closeDropdowns}>Bugünkü Randevular</NavLink>
                      <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/gelecek-randevular" onClick={this.closeDropdowns}>Gelecek Randevular</NavLink>
                      <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/randevular" onClick={this.closeDropdowns}>Geçmiş Randevular</NavLink>
                      <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/randevu-ekle" onClick={this.closeDropdowns}>Yeni Randevu</NavLink>
                    </div>
                  )}
                </div>

                <div className="relative">
                  <button type="button" onClick={this.toggleHesapMenu} className={linkBase + ' inline-flex items-center gap-1'}>
                    Hesap
                    <Chevron />
                  </button>
                  {hesapOpen && (
                    <div className="absolute right-0 mt-2 w-52 rounded-lg border border-slate-800 bg-slate-900 shadow-lg py-1">
                      {isAdmin() && <NavLink exact className={dropdownItem} activeClassName={dropdownItemActive} to="/kullanici-ekle" onClick={this.closeDropdowns}>Kullanıcı Ekle</NavLink>}
                      <NavLink className={dropdownItem + ' hover:text-red-400'} activeClassName={dropdownItemActive} to="/user/logout" onClick={this.closeDropdowns}>Çıkış</NavLink>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <NavLink className={linkBase} activeClassName={linkActive} to="/user/login">Giriş</NavLink>
            )}
          </div>

          <button onClick={this.toggleMenu} className="md:hidden p-2 rounded-lg text-slate-300 hover:bg-slate-800 hover:text-white transition-colors">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden border-t border-slate-800 px-4 py-3 flex flex-col gap-3">
            {isAuthenticated ? (
              <>
                <span className="text-xs font-semibold uppercase tracking-wide text-slate-500 mt-1">Randevular</span>
                <NavLink exact className={linkBase} activeClassName={linkActive} to="/takvim" onClick={this.toggleMenu}>Takvim</NavLink>
                <NavLink exact className={linkBase} activeClassName={linkActive} to="/gunluk-randevular" onClick={this.toggleMenu}>Bugünkü Randevular</NavLink>
                <NavLink exact className={linkBase} activeClassName={linkActive} to="/gelecek-randevular" onClick={this.toggleMenu}>Gelecek Randevular</NavLink>
                <NavLink exact className={linkBase} activeClassName={linkActive} to="/randevular" onClick={this.toggleMenu}>Geçmiş Randevular</NavLink>
                <NavLink exact className={linkBase} activeClassName={linkActive} to="/randevu-ekle" onClick={this.toggleMenu}>Yeni Randevu</NavLink>

                <span className="text-xs font-semibold uppercase tracking-wide text-slate-500 mt-2">Hesap</span>
                {isAdmin() && <NavLink exact className={linkBase} activeClassName={linkActive} to="/kullanici-ekle" onClick={this.toggleMenu}>Kullanıcı Ekle</NavLink>}
                <NavLink className={linkBase + ' hover:text-red-400'} activeClassName={linkActive} to="/user/logout" onClick={this.toggleMenu}>Çıkış</NavLink>
              </>
            ) : (
              <NavLink className={linkBase} activeClassName={linkActive} to="/user/login" onClick={this.toggleMenu}>Giriş</NavLink>
            )}
          </div>
        )}
      </nav>
    );
  }
}

export default Navbar
